module.exports = (__webpack_require__(5))(24);